import { defineRule, configure } from 'vee-validate/compat';
import { localize, setLocale } from '@vee-validate/i18n';
import { between, confirmed, integer, email, max, max_value as maxValue, min_value as minValue, regex, required, } from '@vee-validate/rules';
import translate from '~/zf/frontend/common/localization/translate';
import LocalizationService from '~/zf/frontend/common/localization/LocalizationService';
function parseValue(value) {
    if (typeof value === 'number')
        return value;
    return parseFloat(value.replace(',', '.'));
}
function introduceRules() {
    defineRule('integer', integer);
    defineRule('email', email);
    defineRule('required', required);
    defineRule('between', (value, params) => between(parseValue(value), params));
    defineRule('min_value', (value, params) => minValue(parseValue(value), params));
    defineRule('max_value', (value, params) => maxValue(parseValue(value), params));
    defineRule('regex', regex);
    defineRule('confirmed', confirmed);
    defineRule('length', (value, length, ctx) => {
        if (length.min < 1) {
            // eslint-disable-next-line fp/no-throw
            throw new Error('The validator needs minLength to be greater or equal to 1.');
        }
        if (value.length >= length.min) {
            return true;
        }
        return translate(`common.validationError.ARRAY_MUST_BE_GREATER_THAN_${length.min === 1 ? 'SINGULAR' : 'PLURAL'}`, [ctx.field, length.min]);
    });
    defineRule('max', max);
    defineRule('notIn', (value, list, ctx) => {
        if (!list.includes(value)) {
            return true;
        }
        return translate('common.validationError.ALREADY_EXIST', [ctx.field]);
    });
    defineRule('greaterThan', (value, greaterThan, ctx) => {
        if (LocalizationService.parseNumber(value) > greaterThan) {
            return true;
        }
        return translate('common.validationError.MUST_BE_GREATER_THAN', [ctx.field, greaterThan]);
    });
    defineRule('lessThan', (value, lessThan, ctx) => {
        if (LocalizationService.parseNumber(value) < lessThan) {
            return true;
        }
        return translate('common.validationError.MUST_BE_LESS_THAN', [ctx.field, lessThan]);
    });
}
async function loadTranslation(locale) {
    const allowedLocales = ['zh', 'en', 'de', 'es', 'fr', 'it', 'pl', 'ja', 'tr', 'us'];
    if (!allowedLocales.includes(locale))
        return null;
    const localesThatNeedMapping = {
        us: 'en',
        zh: 'zh_CN',
    };
    const needsMapping = Object.keys(localesThatNeedMapping).includes(locale);
    const language = needsMapping ? localesThatNeedMapping[locale] : locale;
    return import(`@vee-validate/i18n/dist/locale/${language}.json`);
}
async function setDefaultMessages(locale, translation) {
    configure({
        generateMessage: localize({
            [locale]: translation,
        }),
    });
}
const VeeValidateHelper = {
    introduceRules,
    loadTranslation,
    setDefaultMessages,
    setLocale,
};
export default VeeValidateHelper;
